import React from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ children }) => {
    return createPortal(<div>{children}</div>, document.body);
};
